import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './styles.css';
import Frontpage from './FrontPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/election-map">
      <Frontpage />
  </BrowserRouter>
);
